import { useLayoutEffect, useState } from 'react'
import { AnyComponentType } from 'types/components'
import { ComponentTypes } from 'types/selectComponent'

export const getActivatedComponentsByComponentType = (
  type: ComponentTypes,
  includeArchived: boolean
): AnyComponentType[] => {
  switch (type) {
    case 'module':
      return window.AccountHelper.getComponentModuleSpecsAvailable(includeArchived)
    case 'inverter':
      return window.AccountHelper.getComponentInverterSpecsAvailable(includeArchived)
    case 'other':
      return window.AccountHelper.getComponentOtherSpecsAvailable(includeArchived)
    case 'battery':
      return window.AccountHelper.getComponentBatterySpecsAvailable(includeArchived)
    case 'custom':
      return []
  }
}

const useActivatedComponents = ({
  type,
  includeArchived,
}: {
  type: ComponentTypes
  includeArchived: boolean
}): AnyComponentType[] => {
  const [activeComponentsData, setActiveComponentsData] = useState<AnyComponentType[]>(() =>
    getActivatedComponentsByComponentType(type, includeArchived)
  )

  useLayoutEffect(() => {
    // Refresh activeComponentsData once ordering data get updated
    setActiveComponentsData(getActivatedComponentsByComponentType(type, includeArchived))
  }, [type])

  return activeComponentsData
}

export default useActivatedComponents
